import AnnotationsHandler from '..';
import CaseAPIs from '../../case/apis';
import { C11nEnv } from '../../interpreter/c11n-env';

AnnotationsHandler.registerHandler('@ACTIVE_CASES', (_value: string, c11nEnv: C11nEnv) => {
  return CaseAPIs.getOpenedCaseItems(`${c11nEnv.getContextName()}/${c11nEnv.getContainerName()}`);
});
